import { Handle, Position } from '@xyflow/react';
import { Bot, Star } from 'lucide-react';

import { cn } from '@/lib/utils';

import { AGENT_NODE_COLORS } from '../agent-graph-utils';

import type { AgentNode } from '@repo/shared-types';

const colors = AGENT_NODE_COLORS.ai_agent;
const handleClass = '!h-2 !w-2 !border !border-white dark:!border-neutral-900';

export const AiAgentNode = ({ data, selected }: { data: AgentNode; selected?: boolean }) => {
  const toolCount = data.tools?.length ?? 0;

  const subtitle = [
    toolCount > 0 ? `${toolCount} tool${toolCount === 1 ? '' : 's'}` : 'no tools',
    data.voice_name ? 'voice' : null,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <div className="flex w-[92px] flex-col items-center">
      <div
        className={cn(
          'bg-card relative flex h-14 w-14 items-center justify-center rounded-xl border shadow-sm transition-all',
          'hover:shadow-md',
          selected ? 'border-primary ring-primary/30 ring-2' : 'border-border',
        )}
      >
        <Handle type="target" position={Position.Top} className={cn(handleClass, colors.handle)} />

        <div
          className={cn(
            'flex h-8 w-8 items-center justify-center rounded-lg',
            colors.tint,
            colors.icon,
          )}
        >
          <Bot size={16} />
        </div>

        {data.is_entry && (
          <span className="absolute -top-1 -right-1 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-yellow-400">
            <Star size={8} className="fill-white text-white" />
          </span>
        )}

        <Handle
          type="source"
          position={Position.Bottom}
          className={cn(handleClass, colors.handle)}
        />
      </div>

      <p className="text-foreground mt-1.5 max-w-full truncate text-[10px] leading-tight font-medium">
        {data.name || 'Unnamed'}
      </p>
      <p className="text-muted-foreground max-w-full truncate text-[9px] leading-tight">
        {subtitle}
      </p>
    </div>
  );
};
